import React, { Component, useReducer } from 'react';
import {Table, Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'

  class Programs extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        programs: []
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))
      data.append('trainer_id', cookies.get('token'))

      axios.post(Backend_Url + 'getTrainerFitnessPlansCatalogue', data)
      .then((res) => {
          let result = res.data
            this.setState({programs: result})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      var programs = this.state.programs
      var programs_map = programs.map((program, index) => {
        return<tr onClick={() => this.OnClickProgram(index)}>
          <td>{index+1}</td>
          <td>{program.name}</td>
          <td>{program.audience.substring(0, 20)}<span style={{color: '#666'}}> ...</span></td>
          <td>{program.goal}</td>
          <td>${program.price}</td>
        </tr>
      })
      return (
        <Row>
            <Helmet>
              <title>TRAINER PROGRAMS - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Programs
              </h4>
              <br/><br/>
              <Container>
                <Table style={{}}>
                  <thead style={{color: 'inherit'}}>
                      <tr>
                      <th width='20%'>Program Number</th>
                      <th width='20%'>Program Name</th>
                      <th width='30%'>Assigned To</th>
                      <th width='20%'>Goal</th>
                      <th width='10%'>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {programs_map}
                  </tbody>
                </Table>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Programs);